// export const rootApi = 'http://localhost:3000/api/v1';
export const rootApi = 'https://api.kyrnovarent.itinnove.io/api/v1';
